export default "__VITE_ASSET__D2CUncFP__"